"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const config_1 = __importDefault(require("../config"));
class Network {
    constructor(id, tokens, handlers, methods, entryPoints, blockTerm) {
        this.id = id;
        this.setTokens(tokens);
        this.setHandlers(handlers);
        this.setMethods(methods);
        this.setEntryPoints(entryPoints);
        this.setBlockTerm(blockTerm);
    }
    setTokens(tokens) {
        if (!(tokens instanceof Array)) {
            return;
        }
        this.tokens = tokens;
    }
    setHandlers(handlers) {
        if (!(handlers instanceof Array)) {
            return;
        }
        this.handlers = handlers;
    }
    setMethods(methods) {
        if (!(methods instanceof Array)) {
            return;
        }
        this.methods = methods;
    }
    setEntryPoints(entryPoints) {
        if (!(entryPoints instanceof Array)) {
            return;
        }
        this.entryPoints = entryPoints;
    }
    setBlockTerm(blockTerm) {
        if (typeof blockTerm !== 'number') {
            return;
        }
        this.blockTerm = blockTerm;
    }
    getToken(id) {
        return this.tokens.find(token => token.id === id);
    }
    getTokenByAddress(address) {
        return this.tokens.find(token => token.address.toLowerCase() === address.toLowerCase());
    }
    getTokenEntryPointID(id) {
        return (this.getToken(id) || {}).entryPointID;
    }
    getTokenHandlerID(id) {
        return (this.getToken(id) || {}).handlerID;
    }
    getTokenAddress(id) {
        return (this.getToken(id) || {}).address;
    }
    getTokenIsToken(id) {
        return (this.getToken(id) || {}).isToken;
    }
    getTokenIsComingSoon(id) {
        return (this.getToken(id) || {}).isComingSoon;
    }
    getTokenPairTokens(id) {
        return (this.getToken(id) || {}).pairTokens;
    }
    getTokenReplaceString(id) {
        return (this.getToken(id) || {}).replaceString;
    }
    getTokenImage(id) {
        return (this.getToken(id) || {}).image;
    }
    getTokenFullImage(id) {
        return `${config_1.default.default.host.image}${this.getTokenImage(id) || ''}`;
    }
    getTokenByHandlerID(id) {
        const tokenID = this.getHandlerTokenID(id);
        return this.getToken(tokenID);
    }
    getTokenAddressByHandlerID(id) {
        const tokenID = this.getHandlerTokenID(id);
        return this.getTokenAddress(tokenID);
    }
    getHandler(id) {
        return this.handlers.find(handler => handler.id === id);
    }
    getHandlerTokenID(id) {
        return (this.getHandler(id) || {}).tokenID;
    }
    getHandlerByTokenID(id) {
        const handlerID = this.getTokenHandlerID(id);
        return this.getHandler(handlerID);
    }
    getMethod(id) {
        return this.methods.find(method => method.id === id);
    }
    getMethodSignature(id) {
        return (this.getMethod(id) || {}).signature;
    }
    getMethodOutputTypes(id) {
        return (this.getMethod(id) || {}).outputTypes;
    }
    getEntryPoint(id) {
        return this.entryPoints.find(entryPoint => entryPoint.id === id);
    }
    getEntryPointAddress(id) {
        return (this.getEntryPoint(id) || {}).address;
    }
    getBlockTerm() {
        return this.blockTerm;
    }
}
exports.default = Network;
;
//# sourceMappingURL=Network.js.map